import {ShippingInfoModel} from './ShippingInfo.model';
import {PriceSummaryModel} from './PriceSummary.model';
import {ViolationModel} from './Violation.model';
import {AdditionalFeeModel} from './AdditionalFee.model';
import {MinimumOrderAmountModel} from './MinimumOrderAmount.model';
import {EstimateTotalsResponse} from '@wix/auto_sdk_ecom_current-cart';
import {AppliedCouponModel} from './AppliedCoupon.model';
import {toAppliedCouponSDK} from '../utils/coupon';

export class EstimatedTotalsModel {
  public priceSummary: PriceSummaryModel;
  public shippingInfo: ShippingInfoModel;
  public payNow: PriceSummaryModel;
  public payLater: PriceSummaryModel;
  public additionalFees: AdditionalFeeModel[];
  public violations: ViolationModel[];
  public minimumOrderAmount: MinimumOrderAmountModel;
  public estimatedAmountToPay: number;
  public appliedCoupon: AppliedCouponModel;

  constructor(params: EstimatedTotalsModel) {
    this.priceSummary = params.priceSummary;
    this.shippingInfo = params.shippingInfo;
    this.payNow = params.payNow;
    this.payLater = params.payLater;
    this.additionalFees = params.additionalFees;
    this.violations = params.violations;
    this.minimumOrderAmount = params.minimumOrderAmount;
    this.estimatedAmountToPay = params.estimatedAmountToPay;
    this.appliedCoupon = params.appliedCoupon;
  }

  public static fromSDK(
    estimatedTotals: EstimateTotalsResponse,
    useDeliveryOptionsLibInCart: boolean
  ): EstimatedTotalsModel {
    return new EstimatedTotalsModel({
      additionalFees: (estimatedTotals?.additionalFees ?? []).map(AdditionalFeeModel.fromSDK),
      estimatedAmountToPay: Number(estimatedTotals.priceSummary.total.amount),
      minimumOrderAmount: MinimumOrderAmountModel.fromSDK(estimatedTotals.calculationErrors.orderValidationErrors),
      payLater: PriceSummaryModel.fromSDK(estimatedTotals.payLater),
      payNow: PriceSummaryModel.fromSDK(estimatedTotals.payNow),
      priceSummary: PriceSummaryModel.fromSDK(estimatedTotals.priceSummary),
      shippingInfo: estimatedTotals.shippingInfo
        ? ShippingInfoModel.fromSDK(
            estimatedTotals.shippingInfo,
            estimatedTotals?.calculationErrors?.carrierErrors,
            useDeliveryOptionsLibInCart
          )
        : undefined,
      violations: (estimatedTotals?.violations ?? []).map(ViolationModel.fromSDK),
      appliedCoupon: toAppliedCouponSDK(estimatedTotals.appliedDiscounts),
    });
  }
}
